import VeeValidate, { Validator } from 'vee-validate'

import postalCode from './postalCode'
import entropy from './entropy'
import ipList from './ipList'

const plugin = {
  install(Vue) {
    Validator.extend('postalCode', postalCode, { hasTarget: true })
    Validator.extend('entropy', entropy)
    Validator.extend('ipList', ipList)
    Validator.localize('en')

    Vue.use(VeeValidate)
  }
}

export default plugin
